module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-1.ecdda530.jpg";